import { useEffect } from "react";

const APP_REDIRECT_URI = "dataupgamingmobile://apple-auth";

export default function AppleAuthRedirect() {
  useEffect(() => {
    if (window.opener) return;
    const suffix = window.location.hash || window.location.search || "";
    window.location.replace(`${APP_REDIRECT_URI}${suffix}`);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black px-4">
      <p className="text-gray-700 dark:text-gray-200">Completing Apple sign in...</p>
    </div>
  );
}
